export default __webpack_public_path__ + "static/media/convenio.22ad96c1.png";